import { Component } from '@angular/core';
import { CardItemComponent } from '../../UI/card-item/card-item.component';
@Component({
  selector: 'app-static-card-exam',
  imports: [CardItemComponent],
  templateUrl: './static-card-exam.component.html',
  styleUrl: './static-card-exam.component.css'
})
export class StaticCardExamComponent {


  cardItems: any[] =
    [
      {
        icon: 'Images/card1.jpg',
        name: '1. Start with Topic-Focused Practice',
        discrption: 'Choose questions based on the topic you’ve just revised. This helps you apply knowledge immediately and spot gaps early.'
      }
      ,
      {
        icon: 'Images/card2.jpg',
        name: '2. Check Solutions Carefully',
        discrption: 'Compare your answers with the model solutions and examiner-style explanations to understand what earns marks and what doesn’t.'
      },
      {
        icon: 'Images/card3.jpg',

        name: '3. Simulate Real Exam Conditions',
        discrption: 'Once you’re confident, attempt mixed questions under timed conditions.'
      }
    ]
}
